import { Outlet, useParams } from "react-router";
import { createContext, useContext, useEffect, useState } from "react";
// import { IDisributorInfoExtend, IPartnerExtend } from "./DistributorDetail";
import { apiRemote } from "@/api/wp-api";
import { useAlert } from "@/contexts/AlertContext";
import { decodeId } from "@/utils/decodeId";
import { useCustomBreadcrumb } from "@/contexts/CustomBreadcrumb";
import { IUserCertificateExtend } from "./MyCertificate";

export interface MyCertificateContextType {
    getUserCertificate: () => Promise<any>;
}
const MyCertificateContext=createContext<MyCertificateContextType>({} as any);

export function MyCertificateLayout(){
    const { id } = useParams<{ id: string }>(); 
    const alert=useAlert();

    const getUserCertificate=()=>{
        return apiRemote.getUserCertificates().catch((err: any) => {
            alert.error(err.message);
            return {} as IUserCertificateExtend; // Trả về giá trị mặc định khi có lỗi
        });
    }

    useEffect(()=>{

    },[id]);
    return (
        <MyCertificateContext.Provider value={{getUserCertificate}}>
            <Outlet />
        </MyCertificateContext.Provider>
    )
}

export function useMyCertificateContext(){
    return useContext(MyCertificateContext);
}